import React from 'react'
import { Input } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function ContactBox(props) {
    return (
        <div className="col-lg-4 col-sm-6 contact-first-wrapper wow bounceInUp" data-wow-offset="50" data-wow-duration="1s" data-wow-delay="0.5s">
            <div className="contact-details">
                <div className="contact-icon">
                    <FontAwesomeIcon className="font-icon" icon={props.Icon}/>
                </div>
                <div className="contact-content-dec">
                    <h4>{props.Title}</h4>
                    <p>{props.Content}</p>
                    <a href={props.Link} className="contact-link-iteam">{props.Name}</a>
                </div>
            </div>
        </div>
    )
}

export function TextDiv(props) {
    return (
        <div className="form-group contact-text-box">
            <Input name={props.Name} id={props.Id} type={props.Type} className={props.Class} placeholder={props.Place} />
        </div>
    )
    
}